import "./spinner.css";

const Spinner = ({ variant = "default", className, ...props }: any) => {
  return (
    <span className={`sa-spinner ${variant} ${className || ""}`} {...props} />
  );
};
export { Spinner };
